import { useQuery } from "@tanstack/react-query";
import { useDataProvider } from "ra-core";

import type { NevoraDataProvider } from "../datos/dataProvider";

/** Enlace firmado (una hora) de la foto de un usuario (30); null si no tiene o no se puede ver. */
export const useUrlFoto = (ruta: string | null | undefined) => {
  const dataProvider = useDataProvider<NevoraDataProvider>();
  const { data } = useQuery({
    queryKey: ["nevora", "fotoUsuario", ruta],
    queryFn: () => dataProvider.urlFotoUsuario(ruta!),
    enabled: !!ruta,
    staleTime: 50 * 60 * 1000,
  });
  return ruta ? (data ?? null) : null;
};
